<template>
  <div
    class="mb-6 product-info__countdown"
    v-if="isPre"
  >
    <VueCountdownTimer
      :start-time="getHoursStart"
      :end-time="getHoursEnd"
      :interval="1000"
      :start-label="'Começa em'"
      :end-label="'Encerra em'"
      label-position="begin"
      :end-text="'Evento finalizado!'"
      :day-txt="'dias'"
      :hour-txt="':'"
      :minutes-txt="':'"
      :seconds-txt="''"
      @start_callback="startCallBack('event started')"
      @end_callback="endCallBack('event ended')"
    >
      <template
        slot="countdown"
        slot-scope="scope"
      >
        <span>
          <span v-if="scope.props.days != '00'">
            {{ scope.props.days }} {{ scope.props.dayTxt }}
          </span>
          <span>
            {{ `${scope.props.hours}:${scope.props.minutes}:${scope.props.seconds}` }}
          </span>
        </span>
      </template>
    </VueCountdownTimer>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    isPre: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      day: Math.ceil(Math.random() * 10),
    };
  },
  computed: {
    ...mapState('Data/Auctions', [
      'lot',
    ]),
    getHoursStart() {
      return moment.unix(this.lot.starts_at);
    },
    getHoursEnd() {
      return moment.unix(this.lot.ends_at);
    },
  },
  methods: {
    startCallBack() {},
    endCallBack() {},
  },
};
</script>

<style lang="scss" scoped>
.product-info {
  &__countdown {
    font-weight: bold;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: -0.015em;
    color: #18a0fb;
  }
}
</style>
